import React from "react";
import loadingSpinner from "../assets/svg/loadingSpinner.svg"

const Spinner = () => {
	return (
		<div className="component_wrapper">
			<img
				src={loadingSpinner}
				alt="Loading..."
				className="svg"
			/>
			<p>Loading...</p>
		</div>
	);
};

export default Spinner;
